import styles from './result.module.scss';

const Result = ({ focused, handleClick, index, item, setFocused }) => {
    const { First_Name, Last_Name, Registration_Name, Gender } = item;

    const onMouseOver = () => {
        setFocused(index);
    };

    const isHighlighted = focused === index;

    return (
        <li className={styles.Result}>
            <button
                type="button"
                className={`${styles.ResultItem} ${isHighlighted ? styles.ResultActive : ''}`}
                onClick={() => handleClick(index)}
                onMouseOver={onMouseOver}
                onFocus={onMouseOver}
            >
                <div>
                    {First_Name} {Last_Name}
                </div>
                <div>
                    <span className={styles.gender}>{Gender}</span>
                    <span className={styles.hcpc_reg_name}>{Registration_Name}</span>
                </div>
            </button>
        </li>
    );
};

export default Result;
